import React from 'react';
import { FormattedDate } from 'react-intl';
import translations from '@nike/gameday-translations/web';
import { deptLanguageTranslations, getUserRole } from '../../util/languageTranslations';

import { Button, Currency } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export default [
  {
    header: <TranslatedCopy id='global.department' />,
    id: 'departmentName',
    cell: cart => {
      const { en } = translations;

      return getUserRole() && en[`shop.deptSelect.deptName.${cart.departmentNumber}`] ? (
        <>
          {cart.departmentName}
          <br />
          {deptLanguageTranslations(cart.departmentName, cart.departmentNumber).toUpperCase()}
        </>
      ) : (
        <>{cart.departmentName}</>
      );
    }
  },
  {
    header: <TranslatedCopy id='global.createdBy' />,
    id: 'createdBy'
  },
  {
    header: <TranslatedCopy id='global.orderType' />,
    id: 'orderType',
    cell: cart => <TranslatedCopy id={`global.order.type.${cart.orderType}`} />
  },
  {
    header: <TranslatedCopy id='openCarts.dateCreated' />,
    id: 'modifiedAt',
    cell: cart => <FormattedDate value={cart.modifiedAt} />
  },
  {
    header: <TranslatedCopy id='global.total' />,
    id: 'totalWholesale',
    cell: (cart, { currencyCode }) => <Currency value={cart.totalWholesale || '0'} type={currencyCode} />
  },
  {
    id: 'shop',
    cell: (cart, { handleOpenCartClick }) => (
      <Button
        secondary
        data-desc={`cart_approval__shop_${cart.orderType}`}
        extraClassName='u-full-width'
        onClick={e => handleOpenCartClick(cart.id, cart.departmentNumber, cart.orderType, e)}
      >
        <TranslatedCopy id='openCarts.table.cart.link' />
      </Button>
    )
  }
];
